import styled from "styled-components";

export const StyledComparisonWrap = styled.div`
  margin-top: 50px;
`;

export const StyledDescHeader = styled.p`
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  margin: 8px 0 32px;
`;
